export const checkEmpty = (fields) => {
    return fields.some((field) => field === '');
};
